import React, {FC} from 'react';

import {StaticFormItem} from 'components/@common/inputs/static-form-item/static-form-item';
import {CustomSelect} from 'components/form/inputs/custom-select';
import {selectContextRawData} from 'modules/context/context-selector';
import {getTaxForecastDataByRequestId} from 'pages/ais/submit-income-tax-forecast/api/thunks';
import {selectTaxForecastsFiltersData} from 'pages/ais/submit-income-tax-forecast/model/slice';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {aisSliceActions} from 'store/slices/ais-slice/ais-slice';

import s from './tax-forecast-filters.module.less';

export const TaxForecastFilters: FC = () => {
    const dispatch = useAppDispatch();
    const {
        requestId,
        status,
        dateForecast,
    } = useAppSelector(selectTaxForecastsFiltersData) ?? {};
    const {organizationId} = useAppSelector(selectContextRawData) ?? {};

    const handleRequestIdChange = (value: string | undefined) => {
        if (value) {
            dispatch(getTaxForecastDataByRequestId({requestId: value}));
        } else {
            dispatch(aisSliceActions.resetTaxForecasts());
        }
    };

    return (
        <div className={s.container}>
            <StaticFormItem
                classNames={{
                    wrapperClassName: s.select,
                }}
                label="Номер запроса"
                customValue={(
                    <CustomSelect
                        value={requestId}
                        onChange={handleRequestIdChange}
                        settings={{
                            url: 'ais/valueLists/INCOME_TAX_FORECAST_REQUESTS',
                            labelPath: 'meaning',
                            valuePath: 'meaning',
                            placeholder: 'Выберите номер запроса',
                            showSearch: true,
                            isClearable: true,
                            fetchTrigger: organizationId,
                            useUndefinedAfterEntriesChanged: true,
                        }}
                        fixedDropdown={false}
                    />
                )}
            />
            {(status !== undefined) && (
                <StaticFormItem
                    classNames={{
                        wrapperClassName: s.status,
                        valueClassName: s['text-gray'],
                    }}
                    label="Статус"
                    value={status ? 'Завершен' : 'Новый'}
                />
            )}
            {dateForecast && (
                <StaticFormItem
                    classNames={{
                        wrapperClassName: s['form-item'],
                        valueClassName: s['text-gray'],
                    }}
                    label="Дата расчета прогноза на стороне НО"
                    value={dateForecast}
                />
            )}
        </div>
    );
};
